import React from 'react';

export function Label({ children }: { children: React.ReactNode }) {
    return <label className="block text-sm font-medium text-gray-700 mb-1">{children}</label>;
}
export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
    return (
        <input
            {...props}
            className="w-full rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-orange-400"
        />
    );
}
export function Button(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            className="w-full rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-medium px-4 py-2"
        />
    );
}
export function Card({ children }: { children: React.ReactNode }) {
    return <div className="rounded-2xl border bg-white p-5 shadow-sm">{children}</div>;
}
